import React, { FC, useContext, useState } from 'react';

import { Grid, Paper } from '@material-ui/core';

import { GlobalContext } from '../../../../../../store';

import Button from '../../../../../../components/Button';
import DatePicker from '../../../../../../components/DatePicker';
import { FormConsumer, FormProvider, IFormAttributes } from '../../../../../../components/Forms';
import Input from '../../../../../../components/Input';
import YesNoSwitch from '../../../../../../components/YesNoSwitch';
import { useBoolean } from '../../../../../common/Hooks/useBoolean.hook';
import { NewSeasonStyled } from './NewSeason.Styles';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

export interface ICreateSeasonForm {
  id?: string | number;
  end: string;
  name: string;
  start: string;
  useClubIndexes: boolean;
}

const defaultRound: ICreateSeasonForm = {
  end: '',
  name: '',
  start: '',
  useClubIndexes: false
};

interface IProps {
  hideButton?: boolean;
  defaultValues?: ICreateSeasonForm;
  hideEditionForm?: () => void;
}

const NewSeason: FC<IProps> = props => {
  const { hideButton, defaultValues, hideEditionForm } = props;

  const {
    actions: {
      adminClubs: { createSeason, editSeason }
    }
  } = useContext(GlobalContext);

  const { clubId } = useRouteInfoState();

  const [displayForm, setDisplayForm] = useState(false);
  const [formErrors, setFormErrors] = useState('');

  const [useClubIndexes, , toggleUseClubIndexes] = useBoolean(false);

  const showForm = () => {
    setDisplayForm(true);
  };

  const hideForm = () => {
    if (defaultValues && hideEditionForm) {
      hideEditionForm();
    }
    setDisplayForm(false);
  };

  const onSubmit = async (season: ICreateSeasonForm) => {
    const response = defaultValues
      ? await editSeason(season, clubId, defaultValues.id)
      : await createSeason(season, clubId);

    if (response.errors) {
      setFormErrors(response.errors.season.msg || '');
    } else {
      hideForm();
    }
  };

  return (
    <NewSeasonStyled>
      {!hideButton && (
        <Button
          className="seasons-cta"
          id="create-event-submit"
          variant="contained"
          color="primary"
          type="submit"
          disabled={displayForm}
          onClick={showForm}
        >
          ADD A NEW SEASON
        </Button>
      )}

      <Paper elevation={2} className={`paper row ${displayForm || defaultValues ? '' : 'hidden'}`}>
        <FormProvider
          defaultValues={defaultValues || defaultRound}
          onSubmit={onSubmit}
          validations={{}}
        >
          <FormConsumer>
            {({ values, formActions: { setValue } }: IFormAttributes) => (
              <>
                <div className="form">
                  <Grid className="grid head" container={true} spacing={4}>
                    {false && (
                      <Grid className="grid-item" item={true} xs={4}>
                        <Input
                          label="Name"
                          type="text"
                          id="season-name"
                          fullWidth={true}
                          value={values.name}
                          onChange={setValue('name')}
                          onError={setValue('name')}
                        />
                      </Grid>
                    )}

                    <Grid className="grid-item" item={true} xs={2}>
                      <DatePicker
                        label="START"
                        placeholder="01/01/2019"
                        value={values.start ? values.start : ''}
                        onChange={setValue('start')}
                        onError={setValue('start')}
                      />
                    </Grid>

                    <span className="date-separator">TO</span>

                    <Grid className="grid-item" item={true} xs={2}>
                      <DatePicker
                        label="END"
                        placeholder="01/01/2019"
                        value={values.end ? values.end : ''}
                        onChange={setValue('end')}
                        onError={setValue('end')}
                      />
                    </Grid>

                    {formErrors && (
                      <Grid className="grid-item form-errors" item={true} xs={12}>
                        <p className="form-errors">{formErrors} </p>
                      </Grid>
                    )}
                  </Grid>

                  {false && (
                    <Grid className="grid use-indexes" container={true} spacing={4}>
                      <Grid className="grid-item" item={true} xs={4}>
                        <p className="subsection-label">Use Club indexes</p>
                      </Grid>

                      <Grid className="grid-item" item={true} xs={2}>
                        <YesNoSwitch
                          labelNo="No"
                          labelYes="Yes"
                          onChange={toggleUseClubIndexes}
                          checked={useClubIndexes}
                        />
                      </Grid>

                      {useClubIndexes && (
                        <Grid className="grid-item" item={true} xs={6}>
                          <p className="subsection-label">How many scores count?</p>

                          <div className="subsection-fields">
                            <Input
                              type="number"
                              value={values.lowScores}
                              onChange={setValue('lowScores')}
                              onError={setValue('lowScores')}
                            />

                            <span className="input-filler">lowest of the last</span>

                            <Input
                              type="number"
                              value={values.clubEvents}
                              onChange={setValue('clubEvents')}
                              onError={setValue('clubEvents')}
                            />

                            <span className="input-filler">club events</span>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                  )}
                </div>

                <div className="save-buttons">
                  <Button className="seasons-cta" variant="contained" color="primary" type="submit">
                    Save
                  </Button>

                  <Button
                    className="seasons-cta"
                    variant="outlined"
                    color="primary"
                    type="button"
                    onClick={hideForm}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            )}
          </FormConsumer>
        </FormProvider>
      </Paper>
    </NewSeasonStyled>
  );
};

export default NewSeason;
